<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'teamTypesCrud'"
          :crudName="$t('teamType.title')"
          :newText="$t('teamType.form.newText')"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="$hasAbility('equipe.gerenciar')"
          :enableEdit="$hasAbility('equipe.gerenciar')"
          :enableDelete="$hasAbility('equipe.gerenciar')"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "teamTypesTable",
      columns: ["id", "name", "status", "actions"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "status"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          name: this.$t("teamType.table.name"),
          status: this.$t("common.status"),
          actions: this.$t("common.actions"),
        },
        sortable: ["id", "name", "status"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: this.$t("teamType.table.filterBy"),
          defaultOption: this.$t("common.select"),
        },
        listColumns: {
          status: [
            { id: 1, text: this.$t("common.active") },
            { id: 0, text: this.$t("common.inactive") },
          ],
        },
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this),
          );
        },
      },
      endPoint: "team_types",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
